import httpUserClient from '@/plugins/httpUserClient';

export default {
  index(catalog, category, currentPage, perPage = 10) {
    if (category) {
      return httpUserClient.get(`display/materials?catalog=${catalog}&category=${category}&page=${currentPage}&per_page=${perPage}`);
    } else {
      return httpUserClient.get(`display/materials?catalog=${catalog}&page=${currentPage}&per_page=${perPage}`);
    }
  },
  show(id) {
    return httpUserClient.get(`display/materials/${id}`);
  },
};



// WEBPACK FOOTER //
// ./src/apiSet/userApis/resources/video.js